import { useQuery } from 'vue-query';
import apiAxios from '../../apiAdminAxios';

const fetchEmployers = async ({ page, per_page, keyword, with_credits }) => {
  let URL = `?page=${page || 1}`;

  if (per_page) {
    URL += `&per_page=${per_page}`;
  }
  if (keyword) {
    URL += `&keyword=${keyword}`;
  }
  // the credit aggregates are expensive server side, so they are opt-in
  if (with_credits) {
    URL += '&with_credits=1';
  }

  const { data } = await apiAxios.get(`/admin/employers${URL}`);
  return data;
};

const updateEmployer = async ({ id, status }) => {
  const res = await apiAxios.put(`/admin/employers/${id}`, { status });
  return res;
};
const editEmployerSubscription = async ({ month, half_year, year, id }) => {
  const res = await apiAxios.post(`/admin/employers/edit/subscription/${id}`, {
    month,
    half_year,
    year,
  });
  return res;
};
const editEmployerServiceFee = async ({ fee, id }) => {
  const res = await apiAxios.post(`/admin/employers/edit/service-fee/${id}`, { fee });
  return res;
};
const signAsEmployer = async ({ email }) => {
  const { data } = await apiAxios.post(`/admin/employers/signas`, { email });
  return data;
};

const searchEmployers = async ({ name } = {}) => {
  const params = new URLSearchParams();
  if (name) params.set('name', name);
  const suffix = params.toString() ? `?${params.toString()}` : '';
  const { data } = await apiAxios.get(`/admin/employers/search${suffix}`);
  return data;
};

// queries
const useEmployersQuery = ({ page, per_page, keyword, with_credits }) =>
  useQuery(
    ['admin/employers', page, per_page, keyword, with_credits ? 1 : 0],
    () => fetchEmployers({ page, per_page, keyword, with_credits }),
    { refetchOnMount: false },
  );

export default {
  fetchEmployers,
  updateEmployer,
  signAsEmployer,
  searchEmployers,
  useEmployersQuery,
  editEmployerSubscription,
  editEmployerServiceFee,
};
